<template>

	<section id="ai_order_print">
		<div class="content printCont">
			<div class="contIn">
				<div class="boardTit printTit">기공의뢰서 상세</div>
				<div class="printSub">[ 접수번호 {{ items.aiorder_no }}]</div>

				<div class="aiorder_view">

					<!-- // 기공의뢰서 시작 -->
					<div class="aiLeft aiOrderdataWrap">
						<input type="hidden" name="mode" value="view">
						<input type="hidden" v-model="items.id">
						<input type="hidden" v-model="orderJsonData.prosthesis_cnt">
						<input type="hidden" v-model="items.remake_cnt">
						<input type="hidden" v-model="items.hospital_mb_id">
						<input type="hidden" v-model="items.lab_mb_id">

						<div class="ai_cont ai_cont2">
							<div class="boardTitWrap basicInfo">
								<div class="boardTit">기본 정보<span v-if="items.basic_info" class="text-red">&check;</span>
								</div>
								<div class="ai_date">
									<div v-if="items.order_status === 'ords3'" class="cancelDate">출고 완료 <span>{{ commonjs.dateFormatYMDHis(items.order_complete_datetime) }}</span></div>
									<div v-if="items.order_status === 'ords4'" class="cancelDate">주문 취소 <span>{{ commonjs.dateFormatYMDHis(items.order_cancel_datetime) }}</span></div>
								</div>
							</div>

							<table class="ai_order_table">
								<tbody>
									<tr>
										<th>환자명</th>
										<td>{{ orderJsonData.patientName }}</td>
										<th>나이 (성별)</th>
										<td>{{ orderJsonData.patientAge ? `${orderJsonData.patientAge}세` : '' }} {{ orderJsonData.patientGender ? `(${orderJsonData.patientGender}성)` : '' }}
										</td>
									</tr>
									<tr>
										<th>차트번호</th>
										<td>{{ orderJsonData.chartNum }}</td>
										<th>감염성질환</th>
										<td><span class="proStatus" :class="[{ yes: orderJsonData.infection === 'Y' }, { no: orderJsonData.infection === 'N' }]">{{ orderJsonData.infection ? orderJsonData.infection : '-' }}</span></td>
									</tr>
									<tr>
										<th>치과명</th>
										<td>{{ orderJsonData.hospitalName ? orderJsonData.hospitalName :
					(globaljs.acc_type === 'lab') ? others.mb_nick : globaljs.mb_nick }}</td>
										<th>담당자명</th>
										<td>{{ orderJsonData.hospitalName2 }}</td>
									</tr>
									<tr>
										<th>기공소명</th>
										<td>{{ orderJsonData.labName ? orderJsonData.labName : (globaljs.acc_type ===
					'lab') ? globaljs.mb_nick : others.mb_nick }}</td>
										<th>차트접수일</th>
										<td>{{ orderJsonData.chartDate }}</td>
									</tr>
									<tr>
										<th>주문일</th>
										<td>{{ orderJsonData.registerDate }}</td>
										<th>희망완료일</th>
										<td>
											{{ orderJsonData.completeHopeDate }}
											<b v-if="items.order_status != 'ords3' && items.order_status != 'ords4'" class="d-day" :class="{ 'zero': commonjs.calculateDDay(orderJsonData.completeHopeDate) }">
												{{ items.order_status === 'ords1' || items.order_status === 'ords2' ?
					`(${commonjs.calculateDDay(orderJsonData.completeHopeDate)})` : '-' }}
											</b>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="ai_cont ai_cont3">
							<div class="boardTitWrap">
								<div class="boardTit">발송물품<span v-if="items.item_info" class="text-red">&check;</span>
								</div>
								<div class="form-group scan">
									<label class="form-label">구강스캔</label>
									<p class="form-control"><span class="proStatus"
											:class="orderJsonData?.scan === 'scan' ? 'yes' : 'no'">{{ orderJsonData?.scan === 'scan' ? 'Y' : 'N' }}</span></p>
								</div>
							</div>

							<div id="ai_prosthesis" class="ai_c3_form">
								<div v-if="prosthesis_sum < 1" class="form-group noPro_list">
									<p class="icon_notice_g"></p>
									<p>발송물품 없음</p>
								</div>
								<table v-else class="ai_order_table">
									<tr v-if="orderJsonData.prosthesis1 > 0">
										<th>상악Tray</th>
										<td>{{ orderJsonData.prosthesis1 }}<small>개</small></td>
									</tr>
									<tr v-if="orderJsonData.prosthesis2 > 0">
										<th>하악Tray</th>
										<td>{{ orderJsonData.prosthesis2 }}<small>개</small></td>
									</tr>
									<tr v-if="orderJsonData.prosthesis3 > 0">
										<th>Bite Tray</th>
										<td>{{ orderJsonData.prosthesis3 }}<small>개</small></td>
									</tr>
									<tr v-if="orderJsonData.prosthesis4 > 0">
										<th>Bite</th>
										<td>{{ orderJsonData.prosthesis4 }}<small>개</small></td>
									</tr>
									<tr v-if="orderJsonData.prosthesis5 > 0">
										<th>상악모델</th>
										<td>{{ orderJsonData.prosthesis5 }}<small>개</small></td>
									</tr>
									<tr v-if="orderJsonData.prosthesis6 > 0">
										<th>하악모델</th>
										<td>{{ orderJsonData.prosthesis6 }}<small>개</small></td>
									</tr>
									<tr v-if="orderJsonData.prosthesis7 > 0">
										<th>Analog</th>
										<td>{{ orderJsonData.prosthesis7 }}<small>개</small></td>
									</tr>
									<tr v-if="orderJsonData.prosthesis8 > 0">
										<th>코핑</th>
										<td>{{ orderJsonData.prosthesis8 }}<small>개</small></td>
									</tr>
									<tr v-if="orderJsonData.prosthesis9 > 0">
										<th>이전모델</th>
										<td>{{ orderJsonData.prosthesis9 }}<small>개</small></td>
									</tr>
									<tr v-if="orderJsonData.prosthesis10 > 0">
										<th>이전보철</th>
										<td>{{ orderJsonData.prosthesis10 }}<small>개</small></td>
									</tr>
								</table>
							</div>

							<div id="ai_prosthesis_detail" class="proView">
								<div class="boardTitWrap">
									<div class="boardTit">의뢰 내용<span v-if="items.prosthesis_info" class="text-red">&check;</span></div>
								</div>
								<ul class="aiProCont_view">
									<aiorder_template_view :orderJsonData="orderJsonData" />
								</ul>

								<div v-if="(orderJsonData.prosthesis_cnt < 1 || orderJsonData.options_1 === '' || orderJsonData.teeth_1 === '')"
									class="form-row rowPro">
									<div class="form-group noPro_list">
										<p class="icon_notice_g"></p>
										<p>의뢰 내용 없음</p>
									</div>
								</div>
							</div>
						</div>

					</div><!-- // .aiLeft -->
					<!-- // 기공의뢰서 끝 -->
				</div>

			</div>
		</div>
	</section>

</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as aiorderjs from '@/components/utils/aiorder';
import * as talkjs from '@/components/utils/talk';
import aiorder_template_view from '@/components/layout/aiorder_template_view';

const route = useRoute();
const router = useRouter();

const today = moment().format('YYYY-MM-DD');

const props = defineProps({
	a_id: {
		type: Number,
		required: true
	},
	id: {
		type: Number,
		required: true
	},
});

const aiorder_id = ref(props.a_id);
const history_id = ref(props.id);

watch(
	() => props.a_id,
	(newVal) => {
		aiorder_id.value = newVal;
	}
);
watch(
	() => props.id,
	(newVal) => {
		history_id.value = newVal;
	}
);

const items = ref([]); // 보철물 (분류+상세+즐겨찾기)
const orderJsonData = ref([]); // order_json_data

const others = ref([]); // 선택한 상대편 정보
const other_id = ref();
watch(
	() => other_id.value,
	(newVal) => {
		getOther();
	}
);

const prosthesis_sum = ref(0);

const goto_url = (url) => {
	router.push(url);
}

onMounted(async () => {
	commonjs.DOMLoaded(); // 240724 헤더가 없는 페이지는 불러와야됨
	aiorderjs.DOMLoaded();

	await getModels();
});

const getOther = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	//params.append('mb_id', globaljs.mb_id);
	params.append('other_id', other_id.value);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/other`, { params });
console.debug(response.data.result);
		if (response.data.result?.[0]) {
			others.value = response.data.result[0];

		}
	} catch (error) {
console.error('Error getOther:', error);
	}
}

const getModels = async () => {

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/aiorder/history/${aiorder_id.value}/${history_id.value}`);
console.debug(response.data.result);
		items.value = response.data.result;
		// 241022 파싱할때 특수문자 오류. sanitizeJSONString함수 추가.
		const sanitizedData = commonjs.sanitizeJSONString(items.value.order_json_data);
		orderJsonData.value = JSON.parse(sanitizedData);
console.debug(orderJsonData.value);
		//items.value.aiorderAiorderDoc[0]

		other_id.value = (globaljs.acc_type === 'lab') ? items.value.hospital_mb_id : items.value.lab_mb_id;
		//await getOther();

		for (let i = 1; i <= 10; i++) {
			if (typeof orderJsonData.value[`prosthesis${i}`] !== 'undefined') {
console.debug(`prosthesis${i}`, parseInt(orderJsonData.value[`prosthesis${i}`]) );
				prosthesis_sum.value += isNaN(parseInt(orderJsonData.value[`prosthesis${i}`])) ? 0 : parseInt(orderJsonData.value[`prosthesis${i}`]);
			}
		}
	} catch (error) {
console.error('Error getModels:', error);
	}
}
</script>